export default {"src":"https://static.spiritory.com/_next/static/media/2.24df73f5.svg","height":189,"width":146,"blurWidth":0,"blurHeight":0};